/**
 * Quick Buy Modal - Initialization Handler
 * Réinitialise le ProductFormV2 quand la modal charge dynamiquement du contenu
 */

(function() {
  'use strict';

  // Observer pour détecter quand le contenu de la modal change
  function observeModalContent() {
    const modal = document.querySelector('apt-quick-buy-drawer');
    if (!modal) return;

    const contentContainer = modal.querySelector('.apt-quick-buy-drawer--content');
    if (!contentContainer) return;

    // Configuration du MutationObserver
    const config = {
      childList: true,
      subtree: true
    };

    // Callback quand le DOM change
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Vérifier si un product-form a été ajouté
          const productForm = contentContainer.querySelector('.product-form');

          if (productForm && !productForm.dataset.initialized) {
            console.log('🔄 Quick Buy Modal: Initializing ProductFormV2...');

            // Marquer comme initialisé pour éviter les doubles initialisations
            productForm.dataset.initialized = 'true';

            // Petit délai pour s'assurer que le DOM est complètement rendu
            setTimeout(() => {
              if (typeof window.ProductFormV2 !== 'undefined') {
                // ProductFormV2 est disponible, l'initialiser
                new window.ProductFormV2(productForm);
                console.log('✅ Quick Buy Modal: ProductFormV2 initialized');

                // Initialiser les dates de livraison
                initDeliveryDateInModal(contentContainer);
              } else {
                // Fallback : attendre un peu plus
                console.log('⏳ ProductFormV2 not ready, waiting 500ms more...');
                setTimeout(() => {
                  if (typeof window.ProductFormV2 !== 'undefined') {
                    new window.ProductFormV2(productForm);
                    console.log('✅ Quick Buy Modal: ProductFormV2 initialized (delayed)');

                    // Initialiser les dates de livraison
                    initDeliveryDateInModal(contentContainer);
                  } else {
                    console.error('❌ ProductFormV2 class not found');
                    console.log('💡 Check that product-form-v2.js is loaded in quick-buy-drawer.liquid');
                  }
                }, 500);
              }
            }, 200);

            // Arrêter d'observer après la première initialisation
            break;
          }
        }
      }
    };

    // Créer et démarrer l'observer
    const observer = new MutationObserver(callback);
    observer.observe(contentContainer, config);

    console.log('👀 Quick Buy Modal: Observer started');
  }

  // Lancer l'observer quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModalContent);
  } else {
    observeModalContent();
  }

  // Support de l'éditeur de thème Shopify
  if (typeof Shopify !== 'undefined' && Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('apt-quick-buy-drawer')) {
        observeModalContent();
      }
    });
  }

  /**
   * Initialise les dates de livraison dans la modal
   * Copie de la fonction du product-form-v2.js
   */
  function initDeliveryDateInModal(container) {
    const deliveryElements = container.querySelectorAll('[data-delivery-date]');

    deliveryElements.forEach(element => {
      const businessDays = parseInt(element.dataset.deliveryDays) || 5;
      const language = element.dataset.deliveryLanguage || 'fr';
      const deliveryDate = calculateDeliveryDate(businessDays);
      const formattedDate = formatDeliveryDate(deliveryDate, language);
      element.textContent = formattedDate;
    });

    console.log('📅 Delivery dates initialized in modal');
  }

  /**
   * Calcule la date de livraison en excluant les week-ends
   */
  function calculateDeliveryDate(businessDays) {
    const today = new Date();
    let daysAdded = 0;
    let currentDate = new Date(today);

    while (daysAdded < businessDays) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }

    return currentDate;
  }

  /**
   * Formate la date selon la langue
   */
  function formatDeliveryDate(date, language = 'fr') {
    const translations = {
      fr: {
        dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
      },
      en: {
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      it: {
        dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
        monthNames: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
      }
    };

    const lang = translations[language] || translations['fr'];
    const dayName = lang.dayNames[date.getDay()];
    const day = date.getDate();
    const month = lang.monthNames[date.getMonth()];

    return `${dayName} ${day} ${month}`;
  }
})();
